import { Component } from '@angular/core';

@Component({
  selector: 'app-sidebar',
  templateUrl: './app-sidebar.component.html'
})
export class AppSidebarComponent { }



// WEBPACK FOOTER //
// ./src/app/shared/app-sidebar/app-sidebar.component.ts